import api from '@/api/wx/common.js'
const state = {
}
const mutations = {
}
const actions = {
    videoClassIndex({ }, params = {}) {
        return api.videoClassIndex(params)
    },
    videoClassCreate({ }, params = {}) {
        return api.videoClassCreate(params)
    },
    videoClassUpdate({ }, params = {}) {
        return api.videoClassUpdate(params)
    },
    videoClassCategory({ }, params = {}) {
        return api.videoClassCategory(params)
    },
    videoClassProduct({ }, params = {}) {
        return api.videoClassProduct(params)
    },
    videoClassCategoryDetail({ }, params = {}) {
        return api.videoClassCategoryDetail(params)
    },
    videoClassInfo({ }, params = {}) {
        return api.videoClassInfo(params)
    },
    videoClassDelisting({ }, params = {}) {
        return api.videoClassDelisting(params)
    },
    videoClassListing({ }, params = {}) {
        return api.videoClassListing(params)
    },
    videoClassCancel_audit({ }, params = {}) {
        return api.videoClassCancel_audit(params)
    },
    getSphClassCommissionRateAPI({ }, params = {}) {
        return api.getSphClassCommissionRateAPI(params)
    },
}
export default {
    namespaced: true,
    state,
    mutations,
    actions,
}